(function () {

    'use strict';

    angular.module('iplusjs.validator.isLowerThan', [
        'iplusjs.utils.misc'
    ])
    .directive('iplusjsIsLowerThan', isLowerThan);

    isLowerThan.$inject = [
        'MiscUtilsService'
    ];
    function isLowerThan(MiscUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, $attrs, $ngModel) {
                var compareVal,
                    equalAllowed = $scope.$eval($attrs.iiltEqualAllowed) || false,
                    byYear = $scope.$eval($attrs.iiltByYear) || false;

                $scope.$watch($attrs.iplusjsIsLowerThan, function (value) {
                    compareVal = MiscUtilsService.getValueCustomObject(value);

                    if (MiscUtilsService.isNotEmpty(compareVal)) {
                        $ngModel.$validate();
                    }
                });

                function isLowerThanValidator(value) {
                    var val = MiscUtilsService.getValueCustomObject(value);

                    return MiscUtilsService.isLowerThan(val, compareVal, {
                        equalAllowed: equalAllowed,  // Sind gleiche Werte erlaubt oder muss der Wert kleiner sein,
                        byYear: byYear // Bei einem Datum nur auf das Jahr schauen
                    });
                }

                $ngModel.$validators.isLowerThan = isLowerThanValidator;
            }
        };
    }
})();
